import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import styles from "../ProspreTestPage/styles.module.scss";
import cx from "classnames";
import NavBar from "../Navigation/NavBar";
import { useSelector } from "react-redux";
// import MacroCalculatorForm from "../ProspreTestPage/components/MacroCalculator";
// import GroceryList from "../ProspreTestPage/components/GroceryList";
import MealPlan from "../ProspreTestPage/components/MealPlan";
import { MACROS_KEY, RESPONSE_KEY, safeGetItem } from "../ProspreTestPage";
import ArrowRight from "./arrow-right.svg";
import httpService from "Root/api/httpService";
import posthog from "posthog-js";
const ProsprePage = () => {
    const [response, setResponse] = useState(safeGetItem(RESPONSE_KEY, {}));
    const [showShoppingList, setShowShoppingList] = useState(false);
    // const [showRawData, setShowRawData] = useState(false);
    // const [isLoading, setIsLoading] = useState(false);
    const user = useSelector((state) => state.user);
    const onSubmit = async (e) => {
        e.preventDefault();
        // submit form data to API
        // if (percCarbs + percFat + percProtein !== 100) {
        //   setError("Macro percentages must add up to 100%");
        //   return;
        // } else {
        //   setError("");
        // }
        // setIsLoading(true);
        const { usePerc, calories, gramsProtein, gramsFat, gramsCarbs, checkboxes, diet, percProtein, percFat, percCarbs, } = safeGetItem(MACROS_KEY, {});
        const protein_g = usePerc
            ? calories * (percProtein / 100 / 4)
            : gramsProtein;
        const fat_g = usePerc ? calories * (percFat / 100 / 9) : gramsFat;
        const net_carbs_g = usePerc ? calories * (percCarbs / 100 / 4) : gramsCarbs;
        const caloriesFromMacros = gramsFat * 9 + gramsProtein * 4 + gramsCarbs * 4;
        const results = await httpService.post("/users/get-meal-plan/", {
            protein_g,
            fat_g,
            net_carbs_g,
            calories: usePerc ? calories : caloriesFromMacros,
            allergies: checkboxes
                ? checkboxes
                    .filter((checkbox) => checkbox.isChecked)
                    .map((checkbox) => checkbox.id)
                    .join(",")
                : "",
            diet,
        });
        setResponse(results);
        localStorage.setItem(RESPONSE_KEY, JSON.stringify(results));
        if (results.success === false) {
            // post
            // setError("Prospre did not respond with a meal plan.");
        }
        else {
            location.href = "/app/my-meal-plan";
        }
        // setIsLoading(false);
    };
    return (_jsxs("div", { style: {
            background: "#F1EBE0",
        }, children: [_jsx(NavBar, { userName: user.full_name, showTop: true, userLoggedIn: true, hasSubscription: user.has_subscription, bannerData: user.banner_data }), _jsxs("div", { style: {
                    width: "100%",
                }, children: [_jsx("div", { className: styles.eyebrow, children: "Made for you" }), _jsxs("h1", { style: {
                            textAlign: "center",
                            fontWeight: "400",
                        }, children: ["7-day meal plan", _jsx("br", {}), "for ", user.name] }), _jsxs("div", { className: cx(styles.badge, styles.hedBadge), children: [_jsx("div", { children: "Download your shopping list" }), _jsxs("button", { onClick: () => {
                                    posthog.capture("download_grocery_list");
                                    window.location.href = "/app/grocery-list/";
                                }, className: cx(styles.downloadBadge, styles.badge), children: ["Download ", _jsx("img", { src: ArrowRight, alt: "Right arrow" })] })] })] }), response && response.meal_plan && (_jsx(MealPlan, { response: response, onSubmit: onSubmit }))] }));
};
export default ProsprePage;
